import { createContext, useContext, useState, type ReactNode } from 'react';

export interface PanelContextValue {
  /** Le panel est-il replié ? */
  isCollapsed: boolean;
  /** Basculer l'état replié */
  toggleCollapsed: () => void;
  /** Le panel est-il collapsible ? */
  collapsible: boolean;
  /** État de chargement */
  isLoading: boolean;
}

const PanelContext = createContext<PanelContextValue | null>(null);

export function usePanelContext() {
  const context = useContext(PanelContext);
  return context;
}

export interface PanelProviderProps {
  children: ReactNode;
  collapsible?: boolean;
  defaultCollapsed?: boolean;
  isLoading?: boolean;
}

export function PanelProvider({
  children,
  collapsible = false,
  defaultCollapsed = false,
  isLoading = false,
}: PanelProviderProps) {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  const value: PanelContextValue = {
    isCollapsed,
    toggleCollapsed: () => setIsCollapsed(prev => !prev),
    collapsible,
    isLoading,
  };

  return <PanelContext.Provider value={value}>{children}</PanelContext.Provider>;
}
